import * as React from 'react';
import glamorous from 'glamorous';

interface VerticalFormProps {
  labelWidth?: number;
}

const Container = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
  '& .bp3-form-group > .bp3-label': {
    fontWeight: 'bold',
  },
  '& .bp3-form-content': {
    width: '100%',
  },
  marginTop: '10px',
  width: '100%',
});

export default class VerticalForm extends React.Component<VerticalFormProps> {
  static defaultProps: Partial<VerticalFormProps> = {
    labelWidth: 150,
  };

  public render() {
    const { labelWidth } = this.props;

    return (
      <Container
        css={{
          '& .bp3-form-group > .bp3-label': {
            minWidth: labelWidth,
          },
        }}
      >
        {this.props.children}
      </Container>
    );
  }
}
